export default __webpack_public_path__ + "static/media/highlighting_headlines_site.27ff6027.svg";